import EventEmitter from "events";

const WebSocketEventEmitter = new EventEmitter();

export default WebSocketEventEmitter;
